export const GET_TERMINALS = "GET_TERMINALS"
export const GET_TERMINAL_REQUESTS = "GET_TERMINAL_REQUESTS"